<template>
  <header class="header">
    <div class="header__content header__content__left">
      <div class="hamburger" id="js-hamburger" @click="toggle">
        <span class="hamburger__line hamburger__line--1"></span>
        <span class="hamburger__line hamburger__line--2"></span>
        <span class="hamburger__line hamburger__line--3"></span>
      </div>
      <nuxt-link :to=redirectPathDefault>
        <img class="header__logo" :src="imageSrc">
      </nuxt-link>
    </div>
    <div class="header__content header__content__right">
      <f-breadcrumb />
      <div class="account">
        <p class="company" v-if="account.is_role_application && account.companies.length == 1">{{ account.workspace.name }}</p>
        <div class="input__select" v-else>
          <select name="workspace" class="workspace" v-model="workspace" @change="changeWorkspace">
            <option :value="company.id" v-for="company in account.companies" :key="company.id">{{ company.name }}</option>
          </select>
        </div>
        <f-header-notification v-if="!isHasRoleApplication" />
        <f-header-account :account="account"/>
      </div>
    </div>
  </header>
</template>

<script>
  import FHeaderAccount from './HeaderAccount';
  import FHeaderNotification from './HeaderNotification';
  import FBreadcrumb from '../Breadcrumb';
  import {mapGetters} from "vuex";
  import accountMixin from "@/mixins/accountMixin";

  export default {
    name: 'f-header',
    components: {
      FHeaderAccount,
      FHeaderNotification,
      FBreadcrumb
    },
    created() {
      this.redirectPathDefault = this.$redirectPathDefault();
      this.$store.commit('setDefaultBreadCrumb',
        {
          name: 'dashboard',
          path: this.redirectPathDefault.path,
        },
      );
    },
    data: (app) => {
      const workspace = app.$store.state.frontend.auth.workspace

      return {
        workspace,
        redirectPathDefault : null,
      }
    },
    mixins: [accountMixin],
    computed: {
      ...mapGetters({
        isHasRoleApplication: 'frontend/auth/isHasRoleApplication',
      }),
      imageSrc() {
        if(this.account?.workspace?.image) {
          return this.account.workspace.image;
        }

        if (this.isHasRoleApplication) {
          return '/frontend/img/logo-application.svg';
        }

        return '/frontend/img/logo.svg';
      }
    },
    methods: {
      toggle() {
        this.$emit('toggle');
        this.$nuxt.$emit('updateSizeCalendar');
      },
      changeWorkspace(event) {
        const value = event.target.value;

        this.$cookies.set('workspace', value)
        this.$store.commit('frontend/auth/setWorkspace', value)

        window.location.href = '/dashboard'
      }
    }
  }
</script>
